import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { seo } from '~/util';
import { levelsQuery } from '~/util/queries/public/levels';
import { useHigherLowerStore } from '~/util/stores/higher-lower';
import { HigherLowerHome } from './-Home';
import { HigherLowerRound } from './-Round';
import { PlacedLevel } from '~/util/types/levels';

export const Route = createFileRoute('/games/higher-lower')({
    loader: async ({ context: { queryClient } }) => {
        return (await queryClient.fetchQuery(
            levelsQuery({
                list: 'classic',
                exclude_pending: true,
                exclude_removed: true,
            }),
        )) as PlacedLevel[];
    },
    head: () => ({
        meta: seo({
            title: 'Higher or Lower',
            description:
                'Compare two AREDL placements and keep the streak alive in Higher or Lower.',
        }),
    }),
    component: HigherLowerLayout,
});

function HigherLowerLayout() {
    const {
        data: {
            currentGameState: {
                anchorLevel,
                guessLevel,
                isComplete,
                isGameOver,
            },
        },
        migrateFromOldData,
    } = useHigherLowerStore();

    useEffect(() => {
        migrateFromOldData();
    }, [migrateFromOldData]);

    return anchorLevel != undefined ||
        guessLevel != undefined ||
        isComplete ||
        isGameOver ? (
        <HigherLowerRound />
    ) : (
        <HigherLowerHome />
    );
}
